import { KatalisTranslationComum } from '../translations.interface';

const messages: KatalisTranslationComum = {
  comum: {
    adicionarPeca: 'Adicionar peça',
    amostra: 'Amostra',
    amostraCatalisador: 'Amostra de catalisador',
    amostrasSelecionadas: 'Amostras selecionadas',
    busca: 'Busca',
    cadastrarAmostras: 'Cadastrar amostras',
    cancelar: 'Cancelar',
    catalisadores: 'Catalisadores',
    codigo: 'Código',
    coleta: 'Coleta',
    coletadoEm: 'Coletado em',
    coletadoPor: 'Coletado por',
    coletarAmostras: 'Coletar Amostras',
    confirmacaoSenha: 'Confirmação de senha',
    confirmar: 'Confirmar',
    confirmarRecebimento: 'Confirmar recebimento',
    data: 'Data',
    detalhes: 'Detalhes',
    descricao: 'Descrição',
    emConstrucao: 'Em construção',
    email: 'Email',
    entrar: 'Entrar',
    enviar: 'Enviar',
    etapa: 'Etapa',
    fornecedor: 'Fornecedor',
    historico: 'Histórico',
    identificacao: 'Identificação',
    informacoesGerais: 'Informações gerais',
    laboratorio: 'Laboratório',
    leituraCodigoDeBarras: 'Leitura código de barras',
    lerCodigoDeBarras: 'Ler código de barras',
    local: 'Local',
    nao: 'Não',
    nenhumaAmostraSelecionada: 'Nenhuma amostra selecionada',
    nomeSistema: 'LIMS Lorene',
    numero: 'Número',
    numeroAmostra: 'Número amostra',
    op: 'OP',
    painelDeControle: 'Painel de controle',
    pedido: 'Pedido',
    pesoTriagem: 'Peso triagem',
    placasEletronicas: 'Placas eletrônicas',
    producao: 'Produção',
    receberAmostras: 'Receber amostras',
    recebidoEm: 'Recebido em',
    recebidoPor: 'Recebido por',
    referencia: 'Referência',
    remover: 'Remover',
    responsavel: 'Responsável',
    sair: 'Sair',
    selecione: 'Selecione',
    senha: 'Senha',
    silo: 'Silo',
    sim: 'Sim',
    solicitarAnalise: 'Solicitar análise',
    urgente: 'Urgente',
  },
};

export default messages;
